/**
 * @desc 查询矿化剂需求季度计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterMineralizerResponse>> {
  return defHttp.post({
    url: '/web/plan/quarter/queryPlanMineralizer',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterMineralizerResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/queryPlanMineralizer',
    data,
  });
}
